import { updateItems } from '@/mocks/homeData';

const typeStyles: Record<string, { bg: string; text: string; icon: string }> = {
  hot: { bg: 'bg-primary-100', text: 'text-primary-600', icon: 'ri-fire-line' },
  new: { bg: 'bg-accent-100', text: 'text-accent-600', icon: 'ri-flashlight-line' },
  update: { bg: 'bg-secondary-100', text: 'text-secondary-600', icon: 'ri-refresh-line' },
};

const typeLabels: Record<string, string> = {
  hot: '热门',
  new: '最新',
  update: '更新',
};

export default function UpdatesTimeline() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-white">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">实时动态</h2>
          <p className="section-subtitle">24小时滚动更新，每分钟都有新鲜瓜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item) => {
            const style = typeStyles[item.type] || typeStyles.new;
            const label = typeLabels[item.type] || '最新';
            return (
              <div key={item.id} className="flex gap-4 group">
                <div className="flex flex-col items-center">
                  <div className={`w-2.5 h-2.5 rounded-full ${style.bg} border-2 ${style.bg.replace('100', '400')} flex-shrink-0 mt-1.5`}></div>
                  <div className="w-px flex-1 bg-background-200 group-last:hidden"></div>
                </div>
                <div className="pb-6 group-last:pb-0 flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400 font-mono">{item.date}</span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${style.bg} ${style.text} flex items-center gap-1`}>
                      <i className={`${style.icon} text-xs`}></i>
                      {label}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed group-hover:text-primary-500 transition-colors cursor-pointer">
                    {item.title}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}